import { Component, OnInit } from '@angular/core';
import { MailConfiguration } from '../../model/mail.model';
import { supportMailConfiguration } from '../../constants/support-contact.constants';

@Component({
    standalone: false,
    selector: 'mibi-footer-nav-container',
    template: `<mibi-footer-nav [supportMailConfig]="supportMailConfig"></mibi-footer-nav>`
})
export class FooterNavContainerComponent implements OnInit {

    supportMailConfig!: MailConfiguration;

    ngOnInit() {
        this.supportMailConfig = supportMailConfiguration;
    }

}
